module.exports = "<div class=\"metrica\">\r\n  <div>{{ title }}</div>\r\n  <div>\r\n    <app-price-resize [value]=\"_value | tns\" [intIncreaseValue]=\"0\" [floatDecreaseValue]=\"4\"></app-price-resize>\r\n  </div>\r\n  <div class=\"bar\">\r\n    <div class=\"inner-bar-container\" [ngStyle]=\"{'width': _width+'%'}\">\r\n      <div class=\"inner-bar\" [ngClass]=\"color\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/metrica/metrica.html
// module id = ../../../../../src/app/components/common/metrica/metrica.html
// module chunks = 0